module.exports = __webpack_public_path__ + "img/lookbook_12_right.44740b9c.png";